import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import { authService } from "api/services/auth.service";
import MainLayout from "components/Layout/MainLayout";
import AdminManagement from "pages/admin-management/AdminManagement";
import CashFundManagement from "pages/cash-fund-management/CashFundManagement";
import AssociationList from "pages/category-group/AssociationList";
import ClassList from "pages/category-group/ClassList";
import ClassRegistration from "pages/category-group/ClassRegistration";
import BoardManagement from "pages/community-group/BoardManagement";
import ReportList from "pages/community-group/ReportList";
import CustomerInquiry from "pages/cs-group/CustomerInquiry";
import SellerCS from "pages/cs-group/SellerCS";
import LoginPage from "pages/login/LoginPage";
import MainHome from "pages/main/MainHome";
import Announcement from "pages/marketing-group/Announcement";
import BannerSetting from "pages/marketing-group/BannerSetting";
import CouponManagement from "pages/marketing-group/CouponManagement";
import HomeScreenSetting from "pages/marketing-group/HomeScreenSetting";
import NotificationManagement from "pages/marketing-group/NotificationManagement";
import PopupManagement from "pages/marketing-group/PopupManagement";
import NaverOrderRegister from "pages/order-management/NaverOrderRegister";
import OrderDetail from "pages/order-management/OrderDetail";
import OrderManagement from "pages/order-management/OrderManagement";
import TravelOrderManagement from "pages/order-management/TravelOrderManagement";
import PaymentManagement from "pages/payment-management/PaymentManagement";
import PointManagement from "pages/point-management/PointManagement";
import CategoryManagement from "pages/product-group/CategoryManagement";
import CollectionManagement from "pages/product-group/CollectionManagement";
import PolicyDetail from "pages/product-group/PolicyDetail";
import PolicyManagement from "pages/product-group/PolicyManagement";
import ProductEdit from "pages/product-group/ProductEdit";
import ProductList from "pages/product-group/ProductList";
import ProductRegistration from "pages/product-group/ProductRegistration";
import ProductTagSetting from "pages/product-group/ProductTagSetting";
import ProductVariants from "pages/product-group/ProductVariants";
import ReviewManagement from "pages/product-group/ReviewManagement";
import AttendanceList from "pages/schedule-group/AttendanceList";
import InstructorScheduleList from "pages/schedule-group/InstructorScheduleList";
import LessonRequestList from "pages/schedule-group/LessonRequestList";
import PracticeReservationList from "pages/schedule-group/PracticeReservationList";
import PracticeScheduleList from "pages/schedule-group/PracticeScheduleList";
import SellerManagement from "pages/seller-management/SellerManagement";
import PracticeSettlement from "pages/settlement-management/PracticeSettlement";
import SettlementManagement from "pages/settlement-management/SettlementManagement";
import SettlementSettings from "pages/settlement-management/SettlementSettings";
import BucketlistCategoryItems from "pages/statistics-group/BucketlistCategoryItems";
import BucketlistStats from "pages/statistics-group/BucketlistStats";
import TicketList from "pages/ticket-group/TicketList";
import TicketPurchaseList from "pages/ticket-group/TicketPurchaseList";
import TourApprovalList from "pages/tour-approval/TourApprovalList";
import TourEdit from "pages/tour-group/TourEdit";
import TourManagement from "pages/tour-group/TourManagement";
import TourRefundPolicy from "pages/tour-group/TourRefundPolicy";
import BrandDetail from "pages/user-group/BrandDetail";
import BrandList from "pages/user-group/BrandList";
import CertificationList from "pages/user-group/CertificationList";
import UserDetail from "pages/user-group/UserDetail";
import UserList from "pages/user-group/UserList";

function PrivateRoute() {
  if (!authService.isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  if (authService.getUser() !== null && !authService.isAdmin()) {
    return <Navigate to="/login" replace />;
  }
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<PrivateRoute />}>
        {/* <Route index element={<Navigate to="/order-management" replace />} /> */}
        <Route path="/" element={<MainHome />} />
        <Route path="/order-management" element={<OrderManagement />} />
        <Route path="/travel-order-management" element={<TravelOrderManagement />} />
        <Route path="/naver-order-register" element={<NaverOrderRegister />} />
        <Route path="/order-management/:orderId" element={<OrderDetail />} />
        <Route path="/payment-management" element={<PaymentManagement />} />
        <Route path="/settlement-management" element={<SettlementManagement />} />
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/product-edit/:id" element={<ProductEdit />} />
        <Route path="/product-approval" element={<ProductRegistration />} />
        <Route path="/review-management" element={<ReviewManagement />} />
        <Route path="/product-tag-setting" element={<ProductTagSetting />} />
        <Route path="/category-management" element={<CategoryManagement />} />
        <Route path="/collection-management" element={<CollectionManagement />} />
        <Route path="/coupon-management" element={<CouponManagement />} />
        <Route path="/popup-management" element={<PopupManagement />} />
        <Route path="/banner-setting" element={<BannerSetting />} />
        <Route path="/home-screen-setting" element={<HomeScreenSetting />} />
        <Route path="/customer-inquiry" element={<CustomerInquiry />} />
        <Route path="/seller-cs" element={<SellerCS />} />
        <Route path="/point-management" element={<PointManagement />} />
        <Route path="/cash-fund-management" element={<CashFundManagement />} />
        <Route path="/admin-management" element={<AdminManagement />} />
        <Route path="/seller-management" element={<SellerManagement />} />
        <Route path="/dashboard" element={<SellerManagement />} />
        <Route path="/certificate-list" element={<CertificationList />} />
        <Route path="/user-list" element={<UserList />} />
        <Route path="/user-list/:id" element={<UserDetail />} />
        <Route path="/brand-list" element={<BrandList />} />
        <Route path="/brand-list/:id" element={<BrandDetail />} />
        <Route path="/tour-approval" element={<TourApprovalList />} />
        <Route path="/class-regist" element={<ClassRegistration />} />
        <Route path="/class-list" element={<ClassList />} />
        <Route path="/policy-management" element={<PolicyManagement />} />
        <Route path="/policy-management/:type/:id" element={<PolicyDetail />} />
        <Route path="/report-list" element={<ReportList />} />
        <Route path="/board-management" element={<BoardManagement />} />
        <Route path="/instructor-schedule-list" element={<InstructorScheduleList />} />
        <Route path="/lesson-request-list" element={<LessonRequestList />} />
        <Route path="/practice-schedule-list" element={<PracticeScheduleList />} />
        <Route path="/practice-reservation-list" element={<PracticeReservationList />} />
        <Route path="/attendance-list" element={<AttendanceList />} />
        <Route path="/ticket-list" element={<TicketList />} />
        <Route path="/ticket-purchase-list" element={<TicketPurchaseList />} />
        <Route path="/association-list" element={<AssociationList />} />
        <Route path="/tour-management" element={<TourManagement />} />
        <Route path="/tour-edit/:id" element={<TourEdit />} />
        <Route path="/tour-refund-policy" element={<TourRefundPolicy />} />
        <Route path="/product-variants" element={<ProductVariants />} />
        <Route path="/review-management" element={<ReviewManagement />} />
        <Route path="/practice-settlement" element={<PracticeSettlement />} />
        <Route path="/settlement-settings" element={<SettlementSettings />} />
        <Route path="/notification-management" element={<NotificationManagement />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/bucketlist-stats" element={<BucketlistStats />} />
        <Route path="/bucketlist-stats/:category" element={<BucketlistCategoryItems />} />
      </Route>
    </Routes>
  );
}

export default App;
